import React from "react";
import SwLoaderImg from "./img/sw-loader.gif";

const SwLoader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className='SwLoaderContainer'>
          <img src={SwLoaderImg} className='SwLoaderImg' alt="Loader" />
        </div>
    </div>
  );
};

export default SwLoader;
